import { FC, useCallback, useEffect, useRef, useState } from 'react';
import { formatFileSize } from '../../utils/helper';
import { assignment } from '../../pages/Assignments/Assignments';
import Loader from '../Loader/Loader';
import './FileViewer.scss';
import { ElectronFileDetail, CordovaFileDetail } from '../../utils/interface';
import { Tooltip } from '@mui/material';
import moment from 'moment';

interface Material {
  filename: string;
  filepath: string;
  filesize: number;
  isclassroom: boolean;
  coverimagepath?: string;
  authorname?: string;
}

type fileDataType = Material | assignment | undefined | CordovaFileDetail |ElectronFileDetail | null;
interface PropsType {
  fileUrl: string;
  fileData: fileDataType;
  onClose: () => void;
  type?: string;
  fileType: "doc" | "ppt" | "excel"
}

const FileViewer: FC<PropsType> = ({ fileUrl, fileData, onClose ,type, fileType}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [iframeSrc, setIframeSrc] = useState<string | null>(null);
  console.log('fileulr',fileUrl);
  console.log('file data',fileData);
  // Effect to handle fetching of file details
  useEffect(() => {
    setIframeSrc(`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(fileUrl)}`);   
  }, [fileData, fileUrl]);

  // Handle iframe load event to hide the loader
  const handleIframeLoad = () => {
    setTimeout(() => {
      setIsLoading(false);
    }, 3000);
  };

  const textRef = useRef<HTMLDivElement>(null);
  const [isEllipsisActive, setIsEllipsisActive] = useState(false);

  // Function to check if text is truncated
  const checkEllipsis = useCallback(() => {
    if (textRef.current) {
      setIsEllipsisActive(textRef.current.scrollWidth > textRef.current.clientWidth);
    }
  }, []);

  useEffect(() => {
    checkEllipsis(); // Check on mount
    window.addEventListener("resize", checkEllipsis); // Recheck on resize

    return () => window.removeEventListener("resize", checkEllipsis); // Cleanup on unmount
  }, [checkEllipsis, fileData?.filename]);

  const fileSizeCheck = (size: number) => {
    const maxSize = fileType === "excel" ? 25 * 1024 * 1024 : 100 * 1024 * 1024;
    return size < maxSize;
  };

  const handleDownload = async () => {
    if (fileUrl) {
      const fileName = fileData?.filename || `download-${moment()?.unix()}`;
      console.log("[log] filename", fileName);
      try {
        const response = await fetch(fileUrl);
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Download failed:", error);
      }
    }
  };

  return (
    <>
      {(fileData?.filesize && fileSizeCheck(fileData?.filesize)) ? (
        <div className="FileViewContainer">
          {(type !== "chat" && type !== "system_messages") ?
            <div className="FileHeader">
              <Tooltip title={isEllipsisActive ? fileData?.filename : ""}>
                <div ref={textRef} className="fileName">
                  {fileData?.filename || 'Untitled File'}
                </div>
              </Tooltip>
              <div className="fileSize">
                Size: {fileData?.filesize ? formatFileSize(fileData.filesize) : '0 MB'}
              </div>
            </div>
            : <></>
          }
          <div className="frameContainer">
            {isLoading && <Loader bottom="110px" />}

            {iframeSrc && (
              <iframe
                src={iframeSrc}
                className="msViewer"
                onLoad={handleIframeLoad}
                style={{ display: isLoading ? 'none' : 'block' }}
                title=" "
                onContextMenu={(e) => e.preventDefault()}
              ></iframe>
            )}
            {((fileType === "doc" || fileType === "excel") && !isLoading && iframeSrc) && <div className={fileType === "doc" ? "hideBottomControls" : "hideExcelFooter"}></div>}
            {(fileType === "doc" && !isLoading && iframeSrc) && <div className="hideBorderTop"></div>}
            {(fileType === "doc" && !isLoading && iframeSrc) && <div className="hideBorderLeft"></div>}
          </div>
        </div>
      ) : (
        <div className='fileErrorContainer'>
          <div className='fileErrorText'>
            <div className='errorText'>{'Unable to preview the file. Please download the file to view it.'}</div>
            <div className='downloadLink'>
              Click <span className='link' onClick={handleDownload}>here</span> to download
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default FileViewer;
